import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const ItemNameCollapsed = ({ fulfillmentPlanId }) => {
  const items = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'items',
    }),
  );

  return items.length ? <FormattedMessage {...messages.numberOfItems} values={{ numberOfItems: items.length }} /> : null;
};

ItemNameCollapsed.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

const ItemNameExpanded = ({ fulfillmentPlanId, fulfillmentPlanItemId = '' }) => {
  const items = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'items',
    }),
  );

  const item = items?.find((i) => i.fulfillmentPlanItemId === fulfillmentPlanItemId);

  return item?.name ?? '';
};

ItemNameExpanded.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  fulfillmentPlanItemId: PropTypes.string,
};

export const ItemName = {
  getMessageDescriptor: () => messages.itemName,
  id: 'item-name',

  render: (data, { allData, isExpanded = false } = {}) => {
    if (!isExpanded && allData?.length > 1) {
      return <ItemNameCollapsed fulfillmentPlanId={data.id} />;
    }

    return <ItemNameExpanded fulfillmentPlanId={data.id} fulfillmentPlanItemId={data.fulfillmentPlanItemId} />;
  },
};
